<div class="modal-header">
  <h3 class="modal-title">{{ title }}</h3>
  <div class="header-actions">
    <i class="fa" [ngClass]="{'fa-plus-square-o': minimise, 'fa-minus-square-o': !minimise}"
       style="margin-right: 10px; cursor: pointer;" (click)="minimise=!minimise"></i>
    <i (click)="cancel()" class="fa fa-times" style="cursor: pointer;"></i>
  </div>
</div>

<div class="modal-body" [hidden]="minimise">
  <form #dataServiceForm="ngForm">
    <div class="fluid-container">
      <div class="form-group mt-3">
        <label>Software ID*</label>
        <input class="form-control" type="text" name="softwareid"
               [(ngModel)]="softwareIdObj.software_id" required>
        @if (dataServiceForm.form?.get('softwareid')?.invalid && dataServiceForm.form?.get('softwareid')?.touched) {
<span class="form-error-container">
          Software ID is required.
        </span>
}
      </div>
      <div class="form-group mt-3">
        <label>Schema Type*</label>
        <input class="form-control" type="text" name="schematype"
               [(ngModel)]="softwareIdObj.schematype" required>
        @if (dataServiceForm.form?.get('schematype')?.invalid && dataServiceForm.form?.get('schematype')?.touched) {
<span class="form-error-container">
          Schema type is required.
        </span>
}
      </div>
    </div>
  </form>
</div>

<div class="modal-footer" [hidden]="minimise">
  <button class="save-button" type="button" [disabled]="saving" (click)="save()">
    @if (saving) {
<span><i class="fa fa-spinner fa-pulse"></i></span>
} Save
  </button>
  <button class="cancel-button" type="button" (click)="cancel()">Cancel</button>
</div>
